import { Stack } from "@mui/joy";
import React from "react";
import { SelectButtonCircleV2 } from "components/common/SelectButtonCircleV2";
import { SelfCheckQuestion } from "components/common/SelfCheckQuestion";
import { useQnAOnboardingPromotion } from "../../../../hooks/useQnAOnboardingPromotion";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export interface QnaAnswerOption {
  id: number;
  text: string;
}

export interface Question {
  questionId: number;
  main: string;
  left: string;
  right: string;
}

const questionList: Question[] = [
  {
    questionId: 1,
    main: "내가 원하는 것은",
    left: "평온한\n" + "마음이다",
    right: "건강한\n" + "라이프스타일이다",
  },
  {
    questionId: 2,
    main: "마음을 치료하는 것은",
    left: "삶 전반에\n" + "영향을 준다",
    right: "일부에만\n" + "영향을 준다",
  },
  {
    questionId: 3,
    main: "내 마음이 안정적이라면",
    left: "스스로를 더\n" + "사랑할 것이다",
    right: "그와 무관하게\n" + "사랑할 것이다",
  },
  {
    questionId: 4,
    main: "내가 겪는 심리적 괴로움은",
    left: "항상\n" + "내 곁에 있다",
    right: "특정한 트리거로\n" + "발생한다",
  },
  {
    questionId: 5,
    main: "내 마음을 힘들게 하는 것은",
    left: "외적인\n" + "요인 때문이다",
    right: "내적인\n" + "요인 때문이다",
  },
  {
    questionId: 6,
    main: "건강한 마음을 갖는 것은",
    left: "삶의 궁극적인\n" + "목표다",
    right: "삶의 여러\n" + "목표 중 하나다",
  },
  {
    questionId: 7,
    main: "마음을 치료하고자 하는 나의 의지는",
    left: "항상 일정하게\n" + "유지된다",
    right: "시간이 흐르며\n" + "들쑥날쑥하다",
  },
  {
    questionId: 8,
    main: "마음이 건강하다는 것은",
    left: "고통을 잘\n" + "이겨낸다는 것이다",
    right: "고통이\n" + "없다는 것이다",
  },
  {
    questionId: 9,
    main: "비약물 심리치료 프로그램은 내게",
    left: "새로운 것을\n" + "알려줄 것이다",
    right: "아무것도 알려주지\n" + "못할 것이다",
  },
  {
    questionId: 10,
    main: "자가치료법을 내게 적용하는 것은",
    left: "건강한 삶을 위해\n" + "필요하다",
    right: "이미 방법을 아니\n" + "필요가 없다",
  },
];

// 옵션 리스트
const options: QnaAnswerOption[] = [
  { id: 1, text: "매우 동의" },
  { id: 2, text: "동의" },
  { id: 3, text: "동의" },
  { id: 4, text: "매우 동의" },
];

export default function Convention_2_QnA_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const pageKey = `convention_2`; // 페이지를 구분할 키 값
  const { currentQuestion, qaList, handleSelectAnswer } =
    useQnAOnboardingPromotion({
      pageKey: pageKey,
      questionList: questionList,
      basePath: `/${versionToPathPrefix(version)}-onboarding/convention/2`,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/convention/3`,
      version: version,
    });

  // 훅이 현재 질문을 찾지 못한 경우 (예: URL에 잘못된 ?q=99 입력)에 대한 방어 코드
  if (!currentQuestion) {
    // 실제 프로덕션에서는 에러 페이지로 리디렉션하거나 첫 질문으로 보내는 것이 좋습니다.
    return <div>잘못된 접근입니다.</div>;
  }

  return (
    <Stack
      sx={{
        width: "100%",
        height: "90%",
        py: "20px",
        px: "24px",
        mx: "auto",
      }}
      justifyContent="center"
    >
      <Stack
        sx={{ flex: 1 }}
        justifyContent="center"
        alignItems={"center"}
        spacing={"24px"}
      >
        <SelfCheckQuestion question={currentQuestion} />
        <Stack
          direction="row"
          sx={{ width: "100%" }}
          justifyContent={"space-between"}
        >
          {options.map((option, optionIndex) => (
            <SelectButtonCircleV2
              key={`${currentQuestion.questionId}-${option.id}`}
              questionId={currentQuestion.questionId}
              selected={
                qaList.find(
                  (qa) => qa.questionId === currentQuestion.questionId
                )?.answerId === option.id
              }
              disable={false}
              option={option}
              handleClick={() =>
                handleSelectAnswer(currentQuestion.questionId, option.id)
              }
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
